import script from "./HeaderLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderLink.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderLink.vue?vue&type=style&index=0&id=b7da7c42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7da7c42"]])

export default __exports__